import CityPageTemplate from "../city-template/CityPageTemplate";
import { fortMitchellConfig } from "./data";

export default function FortMitchellPage() {
  return <CityPageTemplate config={fortMitchellConfig} />;
}